
import React      from 'react';
import CSSModules from 'react-css-modules';
import Helmet     from "react-helmet";

import style from './style.scss';

import MarketingModuleList  from '../MarketingModuleList';
import MarketingCourseList  from '../MarketingCourseList';
import UpcomingEvents       from '../UpcomingEvents';

import { connect }            from 'react-redux';
import * as marketingActions from '../../actions/marketingPage';

class PublicCourseListPage extends React.Component {

    componentDidMount() {

        this.props.refreshModules();
    }

    _handleScroll(move) {

        if (move === 'up') {

            document
                .getElementById('subject-tile-list')
                .scrollIntoView({
                    behavior: 'smooth'
                });

        } else if (move === 'down') {

            document
                .getElementById('course-tile-list')
                .scrollIntoView({
                    behavior: 'smooth'
                });
        }
    }

    _moduleSelected(selectedModule) {
        this.setState({closeCoursePanel: false});
        this.props.moduleSelected(selectedModule)
        this._handleScroll('down');
    }

    _closeCoursePanel() {
        this.setState({closeCoursePanel: true});
        this.props.moduleSelected(null);
        this._handleScroll('up');
    }

    _getEventTypesToShow() {
        const { pathname } = window.location;

        if (pathname === '/courses') {
            return ['classroom', 'webinar'];
        } else if (pathname === '/e-learning') {
            return ['online'];
        } else if (pathname === '/conferences') {
            return ['conference'];
        }

        return null;
    }

    render() {

        return (
            <div>

                <Helmet>
                    <title>Training Courses</title>
                    <meta name="description" content="View all our training courses."/>
                </Helmet>

                    <article className={style['section--module']}>

                        <div className={style['section-content-course']}>

                            <MarketingModuleList
                                showEventTypes={this._getEventTypesToShow()}
                                selectedModule={this.props.selectedModule}
                                onClick={this._moduleSelected.bind(this)}
                                modules={this.props.modules}
                            />
                        </div>

                    </article>

                    <div id="course-tile-list">
                        {this.props.selectedModule && this.props.selectedModule.courses.length > 0 && (
                        <article className={style['section--course']}>

                            <div className={style['section-content']}>

                                <MarketingCourseList
                                    showEventTypes={this._getEventTypesToShow()}
                                    selectedModule={this.props.selectedModule}
                                    onCloseClick={this._closeCoursePanel.bind(this)}
                                />
                            </div>

                        </article>
                        )}
                    </div>

            </div>
        );
    }
}

function mapStateToProps(state) {

    return state.marketingPage;
}

function mapDispatchToProps(dispatch) {

    return {
        moduleSelected(module) {

            dispatch(marketingActions.moduleSelected(module));
        },
        refreshModules() {

            dispatch(marketingActions.refreshModules());
        }
    };
}

export default connect(mapStateToProps, mapDispatchToProps)(CSSModules(PublicCourseListPage, style));


// WEBPACK FOOTER //
// ./components/PublicCourseListPage/index.js